import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "input-wrapper mb-2" }
const _hoisted_2 = { class: "uppercase text-raleway-13" }
const _hoisted_3 = { class: "text text-raleway-13 error pointer t-danger mt-2 password-error" }

import { change } from "@/views/ResetView/type";
import { ref } from "vue";
import { Field } from "vee-validate";


export default /*#__PURE__*/_defineComponent({
  __name: 'passwordComponent',
  props: {
    change: { type: Function },
    error: { type: Boolean },
    name: {},
    errorText: {},
    text: {},
    value: {},
    mini: { type: Boolean },
    tabIndex: {}
  },
  setup(__props: any) {

const props = __props;



const passwordType = ref(true);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(props.text ? _ctx.$tc(props.text) : _ctx.$tc("password")), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex input_password-wrapper", { 'error-input': props.error }])
    }, [
      _createVNode(_unref(Field), {
        maxlength: "68",
        class: _normalizeClass(["input input_password", { 'input-mini': props.mini }]),
        onInput: props.change,
        type: passwordType.value ? 'password' : 'text',
        name: props.name,
        value: props?.value || '',
        tabIndex: props.tabIndex
      }, null, 8, ["class", "onInput", "type", "name", "value", "tabIndex"]),
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (passwordType.value = !passwordType.value), ["self"])),
        class: _normalizeClass(["input_password-img", { close: passwordType.value, open: !passwordType.value }])
      }, null, 2)
    ], 2),
    _createElementVNode("p", _hoisted_3, _toDisplayString(props.errorText), 1)
  ]))
}
}

})